import axios from 'axios';
import { loginreq, req , reqJson } from './axiosFun';
// 创建比赛
export const matchAdd = (params) => { return reqJson("post", `/yunyue-houtai/match/add` , params)};
// 编辑比赛
export const matchUpdate = (params) => { return reqJson("post", `/yunyue-houtai/match/update/${params.id}` , params)};
// 游戏列表
export const matchGames = (params) => { return reqJson("get", `/yunyue-houtai/match/games` , params)};
// 获取比赛列表
export const matchList = (params) => { return reqJson("get", `/yunyue-houtai/match/list/${params.currentPage}/${params.pageSize}` , params)};
// 删除比赛
export const matchDel = (params) => { return reqJson("get", `/yunyue-houtai/match/del/${params}` , params)};
// 发布比赛
export const matchPublish = (params) => { return reqJson("get", `/yunyue-houtai/match/publish/${params}` , params)};
// 获取阶段列表
export const stageList = (params) => { return reqJson("get", `/yunyue-houtai/stage/list/${params}` , params)};
// 添加阶段
export const stageAdd = (params) => { return reqJson("post", `/yunyue-houtai/stage/add` , params)};
// 删除阶段
export const stageDel = (params) => { return reqJson("get", `/yunyue-houtai/stage/del/${params}` , params)};
// 编辑阶段
export const stageUpdate = (params) => { return reqJson("post", `/yunyue-houtai/stage/update/${params.id}` , params)};
// 比赛阶段比赛方式信息
export const matchwayDetail = (params) => { return reqJson("get", `/yunyue-houtai/matchway/detail/${params}` , params)};
// 编辑比赛阶段比赛方式信息
export const matchwaySave = (params) => { return reqJson("post", `/yunyue-houtai/matchway/save` , params)};
// 获取阶段比赛规则信息
export const ruleDetail = (params) => { return reqJson("get", `/yunyue-houtai/rule/detail/${params}` , params)};
// 编辑阶段游戏规则
export const ruleAdd = (params) => { return reqJson("post", `/yunyue-houtai/rule/add` , params)};
// 获取游戏规则路径
export const mjdGamerule = (params) => { return reqJson("get", `/yunyue-houtai/mjd/gamerule/${params}` , params)};
// 获取匹配方式
export const mateDetail = (params) => { return reqJson("get", `/yunyue-houtai/mate/detail/${params}` , params)};
// 编辑匹配方式
export const mateAdd = (params) => { return reqJson("post", `/yunyue-houtai/mate/add` , params)};
// 获取匹配方式
export const promotionDetail = (params) => { return reqJson("get", `/yunyue-houtai/promotion/detail/${params}` , params)};
// 编辑匹配方式
export const promotionSave = (params) => { return reqJson("post", `/yunyue-houtai/promotion/save` , params)};
// 创建奖励
export const rewardSave = (params) => { return reqJson("post", `/yunyue-houtai/reward/save` , params)};
// 获取奖励列表
export const rewardList= (params) => { return reqJson("get", `/yunyue-houtai/reward/list/${params}` , params)};
// 删除奖励
export const rewardDel = (params) => { return reqJson("get", `/yunyue-houtai/reward/del/${params}` , params)};
// 获取场地列表
export const siteList = (params) => { return reqJson("get", `/yunyue-houtai/site/list/${params}` , params)};
// 获取场地详情
export const siteDetail = (params) => { return reqJson("get", `/yunyue-houtai/site/detail/${params}` , params)};
// 删除场地
export const siteDel = (params) => { return reqJson("get", `/yunyue-houtai/site/del/${params}` , params)};
// 添加修改场地
export const siteSave = (params) => { return reqJson("post", `/yunyue-houtai/site/save` , params)};
// 获取机器列表
export const loadMachineList = (params) => { return req("get", "/yunyue-houtai/machine/all"  , params) };
// 获取场地设备列表
export const m2achineList = (params) => { return reqJson("get", `/yunyue-houtai/m2achine/list/${params.id}/${1}/${200}`  , params) };
// 删除场地设备
export const m2achineDel = (params) => { return reqJson("get", `/yunyue-houtai/m2achine/del/${params}`  , params) };
// 添加场地设备
export const m2achineAdd = (params) => { return reqJson("post", `/yunyue-houtai/m2achine/add` , params)};
// 场地设备替换
export const m2achineReplace = (params) => { return reqJson("post", `/yunyue-houtai/m2achine/replace` , params)};
// 场地时间段
export const timeList = (params) => { return reqJson("get", `/yunyue-houtai/time/list/${params}`  , params) };
// 添加时间段
export const timeAdd = (params) => { return reqJson("post", `/yunyue-houtai/time/add`  , params) };
// 删除时间段
export const timeDel = (params) => { return reqJson("get", `/yunyue-houtai/time/del/${params}`  , params) };
// 获取报名列表
export const matchuserList = (params) => { return reqJson("post", `/yunyue-houtai/matchuser/list/${params.page}/${params.pageSize}`  , params) };
// 校验手机号
export const usersWithPhone = (params) => { return reqJson("post", `/yunyue-houtai/users/withPhone`  , params) }
// 手动报名
export const matchuserAdd = (params) => { return reqJson("post", `/yunyue-houtai/matchuser/add/${params.matchid}/${params.type}`  , params.users) };
// 取消报名
export const matchuserDel = (params) => { return reqJson("get", `/yunyue-houtai/matchuser/del/${params}`  , params) };
// 获取场次列表
export const sessionList = (params) => { return reqJson("post", `/yunyue-houtai/session/list`  , params) }
// 获取阶段设备列表
export const getM2achineList = (params) => { return reqJson("get", `/yunyue-houtai/m2achine/list/${params}`  , params) }
// 选手战况
export const sessionResult = (params) => { return reqJson("get", `/yunyue-houtai/session/result/${params}`  , params) }
// 获取晋级列表
export const promotionList = (params) => { return reqJson("post", `/yunyue-houtai/promotion/list`  , params) }
// 查看用户获奖
export const promotionReward = (params) => { return reqJson("post", `/yunyue-houtai/promotion/reward`  , params) }
// 开始时间获取场次结束时间
export const sessionEndtime = (params) => { return reqJson("post", `/yunyue-houtai/session/endtime`  , params) }
// 手动匹配
export const sessionMate = (params) => { return reqJson("post", `/yunyue-houtai/session/mate`  , params) }
// 根据比赛id获取第一阶段设备
export const matchMachine = (params) => { return reqJson("get", `/yunyue-houtai/match/machine/${params}`  , params) }
// 获取比赛用户收货地址
export const matchaddrDetail = (params) => { return reqJson("get", `/yunyue-houtai/matchaddr/detail/${params.stageId}/${params.userId}`  , params) }
// 编辑比赛用户收货地址
export const matchaddrSave = (params) => { return reqJson("post", `/yunyue-houtai/matchaddr/save`  , params) }
// 直播设置
export const matchliveAdd = (params) => { return reqJson("post", `/yunyue-houtai/matchlive/add`  , params) }
// 机器地址管理
export const matchLocationList = (params) => { return reqJson("get", `/yunyue-houtai/matchLocation/list`  , params) }
// 获取大屏链接配置
export const adminScreenDetail = (params) => { return reqJson("get", `/yunyue-houtai/adminScreen/detail/${params}`  , params) }
// 编辑大屏配置
export const adminScreenUpdate = (params) => { return reqJson("post", `/yunyue-houtai/adminScreen/update/${params.id}`  , params) }
// 测试大屏登录
export const matchScreenLogin = (params) => { return reqJson("post", `/yunyue-houtai/matchScreen/login`  , params) }
// 时间测算
export const stageTime = (params) => { return reqJson("post", `/yunyue-houtai/stage/time`  , params) }
// 单独处理场次结束
export const sessionHandler = (params) => { return reqJson("get", `/yunyue-houtai/manager/session/handler/${params}`  , params) }
// 复制比赛
export const matchCopy = (params) => { return reqJson("post", `/yunyue-houtai/match/copy`  , params) }
// 添加比赛游戏
export const matchgameAdd = (params) => { return reqJson("post", `/yunyue-houtai/matchgame/add`  , params) }
// 获取配置比赛游戏列表
export const matchgameSelect= (params) => { return reqJson("get", `/yunyue-houtai/matchgame/select`  , params) }
// 获取全部游戏列表
export const matchgameList= (params) => { return reqJson("get", `/yunyue-houtai/matchgame/list`  , params) }
// 删除配置比赛游戏
export const matchgameDel= (params) => { return reqJson("get", `/yunyue-houtai/matchgame/del/${params}`  , params) }
// 获取直播配置
export const matchliveRule= (params) => { return reqJson("get", `/yunyue-houtai/matchlive/rule/${params}`  , params) }
// 编辑比赛机器信息
export const m2achineUpdate = (params) => { return reqJson("post", `/yunyue-houtai/m2achine/update/${params.id}`  , params) }





// WEBPACK FOOTER //
// ./src/api/competition.js